export const getErrorMessage = (error: any): string => {
  if (error?.response?.data?.detail) {
    const detail = error.response.data.detail;
    if (typeof detail === 'string') {
      return detail;
    }
    if (typeof detail === 'object' && detail.msg) {
      return detail.msg;
    }
    if (Array.isArray(detail)) {
      return detail.map((item: any) => 
        typeof item === 'string' ? item : item.msg || JSON.stringify(item)
      ).join(', ');
    }
    return JSON.stringify(detail);
  }
  
  if (error?.message) {
    return error.message;
  }
  
  if (typeof error === 'string') {
    return error;
  }
  
  return 'Произошла ошибка';
};